export interface Environment {
  authUrl: string;
}

const dev: Environment = {
  authUrl: 'https://id.dev.sick.com/auth/',
};

const test: Environment = {
  authUrl: 'https://id.test.sick.com/auth/',
};

const uat: Environment = {
  authUrl: 'https://id.uat.sick.com/auth/',
};

const prod: Environment = {
  authUrl: 'https://id.sick.com/auth/',
};

const local: Environment = {
  authUrl: 'http://localhost:8080/',
};

/**
 * Injected at build time via Angular's `define` option in angular.json.
 * - 'dev' (default, `npm start`) → connects to dev Keycloak
 * - 'local' (`npm run start:local`) → connects to local Keycloak on port 8080
 */
declare const __DEFAULT_ENV__: string;

const environments: Record<string, Environment> = { dev, test, uat, prod, local };

function selectEnvironment(): Environment {
  switch (window.location.hostname) {
    case 'sickidportal.dev-cloud.sick.com':
      return dev;
    case 'sickidportal.test-cloud.sick.com':
      return test;
    case 'sickidportal.uat-cloud.sick.com':
      return uat;
    case 'sickidportal.cloud.sick.com':
      return prod;
    case 'localhost':
      return environments[__DEFAULT_ENV__] ?? local;
    default:
      return local;
  }
}

export const environment = selectEnvironment();

